import { useEffect, useState } from "react";
import { loadEligibility, ReviewService } from "./PartnerReview";
import { InlineLeadReview } from "./InlineLeadReview";
import { jwtDecode } from "jwt-decode";

export function InlineContractReview({ projectId }: { projectId: string | number }) {
  const token = localStorage.getItem("authUser") || "";
  let role = "";
  try { role = jwtDecode<{ userType?: string }>(token).userType || ""; } catch {}
  const allowed = ["contractor", "homeowner"].includes(role);
  const [service, setService] = useState<ReviewService | null>(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setService(null); setFailed(false); setLoading(true);
    if (!allowed) { setLoading(false); return; }
    loadEligibility(token).then(result => {
      if (active) setService(result.services.find(item => item.source_type === "contract" && String(item.project_id) === String(projectId)) || null);
    }).catch(() => { if (active) setFailed(true); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [projectId, token, allowed, attempt]);
  if (!allowed) return null;
  return <div onClick={event => event.stopPropagation()}>
    {loading && <p className="text-muted small" role="status">Loading review options…</p>}
    {failed && <div role="alert" className="inline-lead-review"><p>Review options couldn’t be loaded.</p><button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setAttempt(value => value + 1)}>Try again</button></div>}
    {service && <InlineLeadReview sourceType="contract" sourceId={projectId} receiverId={service.receiver_id} name={service.receiver_name} initialService={service} />}
  </div>;
}
